export enum TaskEvents {
  'CREATE_TASK' = 'task/create',
  'CREATED_TASK' = 'task/created',
  'EDITED_TASK' = 'task/edited',
  'TASK_COMPLETED' = 'task/completed',
  'DELETED_TASK' = 'task/deleted',
  'OPEN_EDIT_TASK_MODAL' = 'task/modal/opened',
  'CLOSE_EDIT_TASK_MODAL' = 'task/modal/closed',
}
